import { TStoreState } from 'redux/types';
import { createSelector } from '@reduxjs/toolkit';
import {
	TConfirmedOrdersResponsePayload,
	TOrdersStore,
	TVatAndEASFeeResponsePayload,
	TOrderDetailsCombinedResponsePayload,
} from './types';

export const getOrdersState = (state: TStoreState): TOrdersStore => state.orders;

export const getOrders = getOrdersState;

// ==========================================:

export const getConfirmedOrders = createSelector(
	[getOrders],
	(orders: TOrdersStore): TConfirmedOrdersResponsePayload => orders.confirmedOrders,
);

// ==========================================:

export const getConfirmedOrdersLoader = createSelector(
	[getOrders],
	(orders: TOrdersStore): boolean => orders.confirmedOrdersLoader,
);

// ==========================================:

export const getConfirmedOrdersForFilterId = createSelector(
	[getOrders],
	(orders: TOrdersStore): TConfirmedOrdersResponsePayload => orders.confirmedOrdersForFilterId,
);

// ==========================================:

export const getConfirmedOrdersForFilterIdLoader = createSelector(
	[getOrders],
	(orders: TOrdersStore): boolean => orders.confirmedOrdersForFilterIdLoader,
);

// ==========================================:

export const getOrderDetailsCombined = createSelector(
	[getOrders],
	(orders: TOrdersStore): TOrderDetailsCombinedResponsePayload => orders.orderDetailsCombined,
);

// ==========================================:

export const getOrderDetailsCombinedLoader = createSelector(
	[getOrders],
	(orders: TOrdersStore): boolean => orders.orderDetailsCombinedLoader,
);

// ==========================================:

export const createOrderReturnLoader = createSelector(
	[getOrders],
	(orders: TOrdersStore): boolean => orders.createOrderReturnLoader,
);

// ==========================================:

export const createOrderDiscountLoader = createSelector(
	[getOrders],
	(orders: TOrdersStore): boolean => orders.createOrderDiscountLoader,
);

// ==========================================:

export const getVatAndEASFee = createSelector(
	[getOrders],
	(orders: TOrdersStore): TVatAndEASFeeResponsePayload => orders.vatAndEASFee,
);

// ==========================================:

export const getVatAndEASFeeLoader = createSelector(
	[getOrders],
	(orders: TOrdersStore): boolean => orders.vatAndEASFeeLoader,
);
